module.exports = __webpack_public_path__ + "static/media/29ADMSPC32.2ff49eb1.jpg";